import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../globals/constants";
import { useState } from "react";
import { useLangagesStore } from "../../../context/langages";
import { menu as menuEs } from "../../../globals/data/es/menu";
import { menu as menuEn } from "../../../globals/data/en/menu";
import { menu as menuCn } from "../../../globals/data/zh/menu";

function Header() {
    const [isActive, setIsActive] = useState(false);
    const langage = useLangagesStore((state) => state.langage);
    const setLangage = useLangagesStore((state) => state.setLangage);

    function toggleNavClass () {
        setIsActive(!isActive)
    }

    const handleChangeLanguage = (value) => {
        setLangage(value);
    }

    const menu =
      langage === "en" ? menuEn :
      langage === "cn" ? menuCn :
      menuEs;

    return (
        <header className={"site-header header-style-3 mobile-sider-drawer-menu " + (isActive ? "active" : "")}>

            <div className="sticky-header main-bar-wraper  navbar-expand-lg">
                <div className="main-bar">

                    <div className="container-fluid clearfix">

                        <div className="logo-header">
                            <div className="logo-header-inner logo-header-one">
                                <NavLink to="/">
                                    <img src={publicUrlFor("/assets/images/LOGO_ASEMARINSA.webp")} alt="#" />
                                </NavLink>
                            </div>
                        </div>

                        {/* NAV Toggle Button */}
                        <button id="mobile-side-drawer"
                            data-target=".header-nav"
                            data-toggle="collapse"
                            className="navbar-toggler collapsed"
                            onClick={toggleNavClass}
                        >
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar icon-bar-first"></span>
                            <span className="icon-bar icon-bar-two"></span>
                            <span className="icon-bar icon-bar-three"></span>
                        </button>

                        {/* MAIN Vav */}
                        <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-center">

                            <ul className=" nav navbar-nav">
                                <li><NavLink to="/">{menu.home}</NavLink></li>
                                <li><NavLink to="/about-us">{menu.aboutUs}</NavLink></li>
                                <li className="has-child"><NavLink href="#" onClick={e => e.preventDefault()}>{menu.services}</NavLink>
                                    <ul className="sub-menu">
                                        <li><NavLink to="/services/maritime-law">{menu.maritimeLaw}</NavLink></li>
                                        <li><NavLink to="/services/tax-law">{menu.taxLaw}</NavLink></li>
                                        <li><NavLink to="/services/customs-law">{menu.customsLaw}</NavLink></li>
                                        <li><NavLink to="/services/commercial-law">{menu.commercialLaw}</NavLink></li>
                                        <li><NavLink to="/services/insurance">{menu.insurance}</NavLink></li>
                                        <li><NavLink to="/services/administrative-processes">{menu.administrativeProcesses}</NavLink></li>
                                        <li><NavLink to="/services/operations-sts">{menu.stsOperations}</NavLink></li>
                                    </ul>
                                </li>
                                <li><NavLink to="/ofac">{menu.ofac}</NavLink></li>
                                <li><NavLink to="/contact-us">{menu.contact}</NavLink></li>
                                <li className="has-child"><NavLink href="#" onClick={e => e.preventDefault()}>{menu.language}</NavLink>
                                    <ul className="sub-menu">
                                        <li><NavLink to="#" onClick={() => handleChangeLanguage("es")}> <img className="mx-2" src={publicUrlFor("/assets/images/flags/FlagSpain.webp")} alt="#" width={20} />{menu.spanish}</NavLink></li>
                                        <li><NavLink to="#" onClick={() => handleChangeLanguage("en")}> <img className="mx-2" src={publicUrlFor("/assets/images/flags/FlagUnitedStates.webp")} alt="#" width={20} />{menu.english}</NavLink></li>
                                        <li><NavLink to="#" onClick={() => handleChangeLanguage("cn")}> <img className="mx-2" src={publicUrlFor("/assets/images/flags/FlagChina.webp")} alt="#" width={20} />{menu.chinese}</NavLink></li>
                                    </ul>
                                </li>

                            </ul>

                        </div>

                        {/* Header Right Section */}
                        <div className="extra-nav header-2-nav">
                            <div className="extra-cell">
                                <div className="header-nav-call-section">
                                    <div className="detail">
                                        <span className="title">{menu.contactUs}</span>
                                        <span><a href="tel:+50763899494">+507 6389-9494</a></span>
                                    </div>
                                    <div className="media">
                                        <img src={publicUrlFor("/assets/images/call.png")} alt="#" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                {/* SITE Search */}
                <div id="search">
                    <span className="close"></span>
                    <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                        <input className="form-control" name="q" type="search" placeholder="Type to search" />
                        <span className="input-group-append">
                            <button type="button" className="search-btn">
                                <i className="fa fa-paper-plane"></i>
                            </button>
                        </span>
                    </form>
                </div>
            </div>

        </header>
    )
}

export default Header;